module.exports = __webpack_public_path__ + "img/icon_map_1_5_hg_c.7b456a56.png";